import React, { useState, useEffect} from "react";
import { makeStyles, createMuiTheme, ThemeProvider} from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import MessageBox from "../../../components/MessageBox/MessageBox";
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "800px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
		maxHeight:"100%",
		overflow: "auto",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function AddMainNav(props) {
	const {showModal} = props;
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	// const [mainNav, setMainNav] = useState([]);
	// const [cn_fkey, setCnFkey] = useState([]);
	const [arrangement, setArrangement] = useState('');
	const [description, setDescription] = useState('');
	const [icon, setIcon] = useState('');

	const [url, setUrl] = useState('');
	// const [mainNavUrl, setMainNavUrl] = useState('');

	const [btnDisabled, setBtnDisabled] = useState(true);

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	const clearFields = () => {
		//setHasline('');
		setDescription('');
		setUrl('');
	};

	const handleOpen = () => {
		setOpen(true);
		clearFields();
	};

	const handleClose = () => {
		setOpen(false);
	};
	// useEffect(() => { //
	// }, []);

	useEffect(() => {
		if (url && arrangement && description) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [url,arrangement,description]);

	const saveContentNav = async () => {
			// main_nav_href:'braddah/'
			// main_nav_desc:GIBBY
			// arrangement:80
			const formData = new FormData();
			formData.append("main_nav_href", url);
			formData.append("main_nav_desc", description);
			formData.append("icon", icon);
			formData.append("arrangement", parseFloat(arrangement)); 
	
			await axios.post(process.env.REACT_APP_API_URL+'add_main_nav', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					showModal('Added new Main Navigation '+ description, 'success');
					handleClose();
				  }).catch(function (error) {
					showModal('Something went wrong '+ error.message, 'warning');
					handleClose();
				  });
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		saveContentNav();
    }


	return (
		<div>
				<Button variant="contained" color="primary" onClick={handleOpen} style ={{marginTop: "22px", marginLeft:"10px", backgroundColor: "#4caf50", color:"#fff"}}>
					Add Main Nav
				</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
						<h4 id="transition-modal-title">Add New Main Navigation</h4>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={2}>
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Description" variant="outlined" style={{marginTop:"21px"}}  placeholder="Description" fullWidth={true} inputProps={{ 'aria-label': 'Description' }} value={description} onChange={e => setDescription(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="URL" variant="outlined"  placeholder="URL" fullWidth={true} inputProps={{ 'aria-label': 'URL' }} value={url} onChange={e => setUrl(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Icon" variant="outlined"  placeholder="Icon" fullWidth={true} inputProps={{ 'aria-label': 'URL' }} value={icon} onChange={e => setIcon(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" type="number" label="Arrangement" variant="outlined"  placeholder="Arrangement" fullWidth={true} inputProps={{ 'aria-label': 'Arrangement' }} value={arrangement} onChange={e => setArrangement(e.target.value)}/>
								</Grid>	
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<Button type="submit" disabled={btnDisabled} variant="contained" color="primary">
									Add Main Navigation
								</Button>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
